// ProfileTabBar — Portfolio sayfa tab navigasyonu
import { Image, Globe, Video, Mic, BarChart3, Sparkles, MessageSquare } from 'lucide-react'

export type PortfolioTab = 'gallery' | 'web' | 'videos' | 'lipsync' | 'stats' | 'ai-creations' | 'buzz'

interface Props {
  active: PortfolioTab
  onChange: (tab: PortfolioTab) => void
  counts?: Partial<Record<PortfolioTab, number>>
}

const TABS: { key: PortfolioTab; label: string; icon: React.ReactNode }[] = [
  { key: 'ai-creations', label: 'AI Creations', icon: <Sparkles size={15} /> },
  { key: 'gallery', label: 'Gallery', icon: <Image size={15} /> },
  { key: 'videos', label: 'Videos', icon: <Video size={15} /> },
  { key: 'buzz', label: 'Buzz', icon: <MessageSquare size={15} /> },
  { key: 'web', label: 'Web', icon: <Globe size={15} /> },
  { key: 'lipsync', label: 'LipSync', icon: <Mic size={15} /> },
  { key: 'stats', label: 'Stats', icon: <BarChart3 size={15} /> },
]

export default function ProfileTabBar({ active, onChange, counts }: Props) {
  return (
    <nav style={{
      display: 'flex', gap: 4, padding: 4, borderRadius: 14,
      background: 'rgba(255,255,255,0.03)',
      border: '1px solid var(--border-default, #30363d)',
      backdropFilter: 'blur(12px)',
      overflowX: 'auto', WebkitOverflowScrolling: 'touch',
    }}>
      {TABS.map(t => {
        const isActive = active === t.key
        const count = counts?.[t.key]
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            aria-current={isActive ? 'page' : undefined}
            style={{
              flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
              gap: 6, padding: '10px 14px', borderRadius: 10, border: 'none',
              fontSize: 13, fontWeight: 600, cursor: 'pointer', minWidth: 'max-content',
              background: isActive
                ? 'linear-gradient(135deg, #667eea, #764ba2)'
                : 'transparent',
              color: isActive ? '#fff' : 'var(--text-secondary, #8b949e)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: isActive ? '0 4px 16px rgba(102,126,234,0.3)' : 'none',
            }}
          >
            {t.icon}
            <span>{t.label}</span>
            {count !== undefined && count > 0 && (
              <span style={{
                fontSize: 11, padding: '1px 7px', borderRadius: 10, fontWeight: 700,
                background: isActive ? 'rgba(255,255,255,0.2)' : 'rgba(102,126,234,0.12)',
                color: isActive ? '#fff' : '#667eea',
              }}>{count}</span>
            )}
          </button>
        )
      })}
    </nav>
  )
}
